import ExpandMore from '@ixigo/icons/ExpandMore';
import ButtonBase from '@ixigo/iui/ButtonBase';
import Typography from '@ixigo/iui/Typography';
import { formatPrice } from '@repo/shared/utils/priceFormatter';

interface PartialPaymentCardProps {
	iconUrl: string;
	title: string;
	amount: number;
	currency: string;
	subtext: string;
}

export function PartialPaymentCard({
	iconUrl,
	title,
	amount,
	currency,
	subtext,
}: PartialPaymentCardProps) {
	const handleClick = () => {
		document.querySelector('#fare-summary')?.scrollIntoView({
			behavior: 'smooth',
			block: 'center',
		});
	};

	return (
		<div className="bg-primary p-20">
			<ButtonBase
				type="button"
				onClick={handleClick}
				style={{ borderRadius: 15 }}
				className="flex items-center gap-15 p-10 border border-moderate-warning bg-gradient-to-r from-warning-moderate to-primary w-full"
			>
				<div className="flex items-center gap-10 flex-1 min-w-0">
					<img
						src={iconUrl}
						alt=""
						className="shrink-0"
						style={{ width: 42, height: 42 }}
					/>
					<div className="flex flex-col items-start min-w-0 text-left">
						<Typography variant="body-md">{title}</Typography>
						<Typography variant="body-xs" className="text-secondary">
							{subtext}
						</Typography>
					</div>
				</div>
				<div className="flex items-center gap-1 shrink-0">
					<Typography variant="h5" fontWeight="bold">
						{formatPrice(amount, { currency })}
					</Typography>
					<ExpandMore style={{ width: 24, height: 24 }} />
				</div>
			</ButtonBase>
		</div>
	);
}

export default PartialPaymentCard;
